module.exports = __webpack_public_path__ + "img/dracula-18.cd2695be.jpg";